export default "__VITE_ASSET__CL2N29c___"